import { render, staticRenderFns } from "./PlanterIndex.vue?vue&type=template&id=0c8481c7&scoped=true&"
import script from "./PlanterIndex.vue?vue&type=script&lang=js&"
export * from "./PlanterIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8481c7",
  null
  
)

export default component.exports